import { useTranslation } from "react-i18next";
import { colors } from "../../../../data/colors";
import { stdObject } from "../../../../data/types/stdObject";
import { convertHour } from "../../../../utils/convertHour";
import { getParamName } from "../../../MainFrame/functions/getParamName";
import { useMainContext } from "../../../../context/MainContext";
import { rowColor } from "../../../../utils/rowColor";
import { docIdCodes } from "../../../../data/docCodes";

export default function ServiceCard({
  mainData,
  isBigScreen,
}: {
  mainData: stdObject;
  isBigScreen: boolean;
}) {
  const { t } = useTranslation();
  const { statusDict, openWindow } = useMainContext();
  const { type, data } = mainData;

  return (
    <div
      className={"stdButton"}
      onDoubleClick={
        isBigScreen
          ? () =>
              openWindow({
                msgName: "document",
                modalInfo: {
                  title: data[`NOM${type}`],
                  label: `${type}.${data[`SER${type}`]}-${data[`COD${type}`]}`,
                  mainColor: colors.services,
                  typeText: type === "SEV" ? "service" : "",
                  type: docIdCodes[type],
                  isEdit: true,
                  doc: type,
                  serie: data[`SER${type}`],
                  code: data[`COD${type}`],
                },
              })
          : () => {}
      }
      style={{
        color: colors.black,
        backgroundColor: rowColor({
          data,
          index: 0,
          statusCode: `EST3SEV`,
          serviceColor: statusDict[data[`PAG${type}`]].COLPAG,
        }),
        borderRadius: 5,
        textWrap: "wrap",
      }}
    >
      {isBigScreen ? (
        <>
          <div>
            {data[`SER${type}`]}-{data[`COD${type}`]}
          </div>
          <div>
            <b>{t("d.CLI")}:</b> {data[`NOM${type}`]}
          </div>
          <div>
            <b>{t("p.hour")}:</b>{" "}
            {convertHour(data[`FEC2${type}`].split(" ")[1])}
          </div>
          <div>
            <b>{t("p.status")}:</b>{" "}
            {getParamName({
              key: "PAG",
              code: "SEV",
              data,
              statusDict,
            })}
          </div>
        </>
      ) : (
        <div />
      )}
    </div>
  );
}
